import type { GadgetUserPreferences } from '@atlassian/jira-dashboard-user-preference/src/types.tsx';

export const isGadgetConfigured = (userPrefs: GadgetUserPreferences | undefined) =>
	userPrefs?.fields.some(({ name, value }) => name === 'isConfigured' && value === 'true') ?? false;
